import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopEpson = dynamic(() => import("../../components/hardware-partners/EpsonPos/DesktopEpson"), {
    loading: () => <Loading />,
}
);

const MobileEpson = dynamic(() => import("../../components/hardware-partners/EpsonPos/MobileEpson"), {
    loading: () => <Loading />,
}
);

const epson = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>Epson POS Printer Compatible with QueueBuster® | Thermal Receipt Printer Integration</title>
                <meta name="description" content="Connect Epson thermal POS printers with QueueBuster® for seamless billing. Direct ticket printing, fast setup & reliable receipt generation for retail & QSRs." />
                <link rel="canonical" href="https://queuebuster.co/pos-hardware-partners/epson" />
                <link rel="alternate" href="https://queuebuster.co/pos-hardware-partners/epson" hrefLang="en-us" />
                <meta property="og:title" content="Epson POS Printer Integration with QueueBuster | Fast Thermal Billing" />
                <meta property="og:description" content="Epson thermal printers now work smoothly with QueueBuster POS. Enjoy direct ticket printing, hassle-free setup, and reliable performance for every transaction." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images-04.png" />
                <meta property="og:url" content="https://queuebuster.co/pos-hardware-partners/epson" />
                <meta property="og:type" content="website" />
                
            </Head>
            {mobileView ? <MobileEpson /> : <DesktopEpson />}
        </>
    )
}

export default epson